<p *ngIf="item?.rich" class="dynamic-text" [innerHTML]="item?.rich | safeHtml"></p>
